import Cards from 'src/components/Cards';
import Checkbox from '../../components/design-system/Checkbox';

interface IInformationComponent {
  content: string[];
}

export const InformationComponent: React.FC<IInformationComponent> = ({ content }) => (
  <Cards title="Information" styleType="information w-full">
    <ul style={{ width: '300px', textAlign: 'left' }}>
      {content.map((text, index) => (
        <li key={index}>{text}</li>
      ))}
    </ul>
  </Cards>
);

interface IWarningComponent {
  initialCheckBox: boolean;
  setInitialCheckBox: React.Dispatch<React.SetStateAction<boolean>>;
}

export const WarningComponent: React.FC<IWarningComponent> = ({
  initialCheckBox,
  setInitialCheckBox,
}) => (
  <Cards title="Warning" styleType="warning w-full">
    <p>The document number provided is a duplicate document number</p>
    <p>
      Please check the checkbox below to complete the document with a duplicate document number.
    </p>
    <div className="warning-checkbox">
      <Checkbox
        label="Allow duplicate document number"
        checked={initialCheckBox}
        onChange={setInitialCheckBox}
      />
    </div>
  </Cards>
);
